import React from "react";
import {
  VerticalStoriesListBase,
  MetaText,
  Story,
  Title,
  TitleLink,
  MetaInfo,
} from "./vertical-stories-list.styled";
import {
  contentPostReadTime,
  getPublicationDate,
  getEditedDate,
  linkTo,
} from "../../utils/contentUtils";
import { ContentPostFragment } from "../../types/graphql";
import * as FA from "../../styles/fontawesome";

interface IVerticalStoriesListProps {
  verticalStoriesList: Array<ContentPostFragment>;
}

const VerticalStoriesList = (props: IVerticalStoriesListProps) => {
  const stories = props.verticalStoriesList;

  return (
    (stories && stories.length > 0 && (
      <VerticalStoriesListBase>
        <h6>RECENT STORIES</h6>
        {stories?.map((story, index) => {
          const storyData = story?.data;
          const publicationDate = getPublicationDate(story);
          const editedDate = getEditedDate(story);
          const articleDate =
            publicationDate == editedDate ? publicationDate : editedDate;
          return (
            story && (
              <Story key={index}>
                {storyData?.title && (
                  <Title>
                    <TitleLink href={linkTo(story)}>
                      {storyData.title}
                    </TitleLink>
                  </Title>
                )}
                <MetaInfo>
                  {publicationDate && editedDate && (
                    <MetaText>{articleDate}</MetaText>
                  )}
                  {storyData?.content_type == "Article" && (
                    <MetaText>
                      <i css={FA.ClockSolid} />
                      &nbsp;
                      {contentPostReadTime(story)}
                    </MetaText>
                  )}
                </MetaInfo>
              </Story>
            )
          );
        })}
      </VerticalStoriesListBase>
    )) || <></>
  );
};

export default VerticalStoriesList;
